import React, { useEffect, useRef, useState } from "react";
import "./FilmsSection.css";

import filmsBg from "../../assets/Group19.png";
import topPaper from "../../assets/whitepaper.png";
import topRightGroup from "../../assets/firstcollage.png";
import middleLeftGroup from "../../assets/secondcollage.png";
import middleRightPaper from "../../assets/lastpaper.png";
import bottomLeftPaper from "../../assets/lastpaper.png";
import bottomRightFrame from "../../assets/thirdcollage.png";
import yearPaper from "../../assets/smallpaper.png";

const FilmsSection = () => {
  const sectionRef = useRef(null);
  const [showFilms, setShowFilms] = useState(false);

  useEffect(() => {
    const currentSection = sectionRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowFilms(true);
          observer.unobserve(currentSection);
        }
      },
      { threshold: 0.2 }
    );

    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) observer.unobserve(currentSection);
    };
  }, []);

  return (
    <section
    className={`filmsSection ${showFilms ? "showFilmsSection" : ""}`}
    id="films"
    ref={sectionRef}
  >
    <img src={filmsBg} alt="films background" className="filmsBg" />
  
    <div className="filmsWrap">

      <div className="filmsTopPaperWrap">
        <img src={topPaper} alt="top paper" className="filmsTopPaper" />
        <div className="filmsTopText">
          <h2 className="filmsTopTitle">Cinematic Journey</h2>
          <p className="filmsTopDesc">
            AbdelHalim Hafez was a star of Egyptian cinema
            whose films captured romance, emotion, and music.
          </p>
        </div>
      </div>
  

      <div className="filmsFirstTextWrap">
        <div className="filmsYearWrap firstYear">
          <img src={yearPaper} alt="year paper" className="filmsYearPaper" />
          <span className="filmsYearText">1955</span>
        </div>
  
        <h3 className="filmsMovieTitle">Lahn El Wafa</h3>
  
        <p className="filmsMovieDesc longDesc">
          Is one of AbdelHalim Hafez’s most memorable
          musical films. The story follows a young musician
          facing love, sacrifice, and the struggles of life, while
          expressing his emotions through music.
        </p>
      </div>
  
  
      <img
        src={topRightGroup}
        alt="top right group"
        className="filmsTopRightGroup"
      />
  
     
      <img
        src={middleLeftGroup}
        alt="middle left group"
        className="filmsMiddleLeftGroup"
      />
  
   
      <div className="filmsMiddleRightWrap">
        <img
          src={middleRightPaper}
          alt="middle right paper"
          className="filmsMiddleRightPaper"
        />
  
        <div className="filmsMiddleRightText">
          <div className="filmsYearWrap middleYear">
            <img src={yearPaper} alt="year paper" className="filmsYearPaper" />
            <span className="filmsYearText">1956</span>
          </div>
  
          <h3 className="filmsMovieTitle">Dalila</h3>
  
          <p className="filmsMovieDesc">
            Is a classic Egyptian musical film starring Abdel
            Halim Hafez, blending romance, music, and
            emotional storytelling.
          </p>
        </div>
      </div>
  

      <div className="filmsBottomLeftWrap">
        <img
          src={bottomLeftPaper}
          alt="bottom left paper"
          className="filmsBottomLeftPaper"
        />
  
        <div className="filmsBottomLeftText">
          <div className="filmsYearWrap bottomYear">
            <img src={yearPaper} alt="year paper" className="filmsYearPaper" />
            <span className="filmsYearText">1956</span>
          </div>
  
          <h3 className="filmsMovieTitle">Dalila</h3>
  
          <p className="filmsMovieDesc">
            Is a classic Egyptian musical film starring Abdel
            Halim Hafez, blending romance, music, and
            emotional storytelling.
          </p>
        </div>
      </div>
  
   
      <img
        src={bottomRightFrame}
        alt="bottom right frame"
        className="filmsBottomRightFrame"
      />
    </div>
  </section>
  );
};

export default FilmsSection;